import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const navItems = [
  {
    label: 'Mimari',
    children: [
      { label: 'Overview', href: '/architecture', icon: 'ri-code-line', internal: true },
      { label: 'Infrastructure Wide Deduplication', href: '/deduplication', icon: 'ri-stack-line', internal: true },
      { label: 'VergeFS', href: '/vergefs', icon: 'ri-database-2-line', internal: true },
      { label: 'VergeFabric', href: '/vergefabric', icon: 'ri-router-line', internal: true },
      { label: 'Infrastructure Automation', href: '/infrastructure-automation', icon: 'ri-settings-4-line', internal: true },
      { label: 'VergeIQ (AI)', href: '/vergeiq', icon: 'ri-brain-line', internal: true },
    ],
  },
  {
    label: 'Özellikler',
    children: [
      { label: 'Virtual Data Centers', href: '/virtual-data-centers', icon: 'ri-layout-grid-line', internal: true },
      { label: 'High Availability', href: '/high-availability', icon: 'ri-server-line', internal: true },
      { label: 'ioClone', href: '/ioclone', icon: 'ri-file-copy-line', internal: true },
      { label: 'ioReplicate', href: '/ioreplicate', icon: 'ri-flashlight-line', internal: true },
      { label: 'ioFortify', href: '/iofortify', icon: 'ri-shield-check-line', internal: true },
      { label: 'ioMigrate', href: '/iomigrate', icon: 'ri-exchange-line', internal: true },
      { label: 'ioProtect', href: '/ioprotect', icon: 'ri-shield-star-line', internal: true },
      { label: 'ioOptimize', href: '/iooptimize', icon: 'ri-line-chart-line', internal: true },
      { label: 'ioGuardian', href: '/ioguardian', icon: 'ri-safe-line', internal: true },
    ],
  },
  {
    label: 'BT Girişimleri',
    children: [
      { label: 'VMware Alternative', href: '/vmware-alternative', icon: 'ri-server-line', internal: true },
      { label: 'Hyperconverged Alternative', href: '/hci', icon: 'ri-loop-left-line', internal: true },
      { label: 'SAN Replacement', href: '/san-replacement', icon: 'ri-hard-drive-line', internal: true },
      { label: 'Infrastructure Modernization', href: '/infrastructure-modernization', icon: 'ri-building-line', internal: true },
      { label: 'Virtual Desktop (VDI)', href: '/virtual-desktop', icon: 'ri-computer-line', internal: true },
      { label: 'Secure Research Computing', href: '/secure-research-computing', icon: 'ri-lock-line', internal: true },
      { label: 'Edge / ROBO', href: '/edge-robo', icon: 'ri-wifi-line', internal: true },
    ],
  },
  {
    label: 'Blog',
    children: [
      { label: '2026\'da Depolama Yenilemenin Artan Maliyeti', href: '/blog/storage-yenileme-maliyeti-2026', icon: 'ri-hard-drive-line', internal: true },
      { label: 'Hipervizör RAM Tüketimini Nasıl Azaltır', href: '/blog/ram-tuketimi-azaltma', icon: 'ri-cpu-line', internal: true },
      { label: 'VM Yoğunluğunun Gizli Riski: Patlama Yarıçapı', href: '/blog/vm-yogunluk-patlama-yaricapi', icon: 'ri-error-warning-line', internal: true },
      { label: 'Felaket Kurtarmadan ROI Elde Etmek', href: '/blog/felaket-kurtarma-roi', icon: 'ri-shield-star-line', internal: true },
      { label: 'Kurulumu ve Kullanımı Kolay En iyi Alternatif', href: '/blog/kolay-vmware-alternatifi', icon: 'ri-settings-3-line', internal: true },
      { label: 'Sanallaştırma Platformu Alternatifleri İçin Gözden Kaçırılan Kriterler', href: '/blog/vmware-alternatifleri-kriterler', icon: 'ri-list-check-2', internal: true },
      { label: 'Özel Buluta Geçiş', href: '/blog/vmwareden-ozel-buluta', icon: 'ri-cloud-line', internal: true },
      { label: 'Özel Bulut İşletim Sistemi Nedir?', href: '/blog/ozel-bulut-os-nedir', icon: 'ri-question-line', internal: true },
      { label: 'VxRail Alternatifleri ve Migration', href: '/blog/vxrail-alternatifleri', icon: 'ri-exchange-line', internal: true },
      { label: 'Onpremise Migration', href: '/blog/yerinde-vmware-cikisi', icon: 'ri-logout-box-r-line', internal: true },
      { label: 'Tüm Yazılar →', href: '/blog', icon: 'ri-article-line', internal: true },
    ],
  },
  {
    label: 'Nasıl Satın Alırım',
    children: [
      { label: 'Demo Talep Et', href: '/demo', icon: 'ri-calendar-check-line', internal: true },
      { label: 'Sürümler', href: '/versions', icon: 'ri-box-3-line', internal: true },
      { label: 'Test Sürüşü', href: '/test-drive', icon: 'ri-steering-2-line', internal: true },
    ],
  },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [openMenu, setOpenMenu] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChildClick = (child: { href: string; label: string; icon?: string; internal?: boolean }, e: React.MouseEvent) => {
    if (child.internal) {
      e.preventDefault();
      navigate(child.href);
      setOpenMenu(null);
    }
  };

  return (
    <nav
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-white'
      }`}
    >
      <div className="max-w-[1280px] mx-auto px-6 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="flex items-center gap-1 cursor-pointer">
          <span className="text-2xl font-bold text-[#1a1a2e] tracking-tight">verge</span>
          <span className="text-2xl font-bold text-[#e8600a]">.tr</span>
        </a>

        {/* Nav items */}
        <div className="hidden lg:flex items-center gap-0">
          {navItems.map((item) => (
            <div
              key={item.label}
              className="relative group"
              onMouseEnter={() => setOpenMenu(item.label)}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <a
                href={item.href ?? '#'}
                className="flex items-center gap-1 px-3 py-5 text-sm font-medium text-[#1e293b] hover:text-[#e8600a] transition-colors cursor-pointer whitespace-nowrap"
                rel="nofollow noreferrer"
              >
                {item.label}
                {item.children && <i className="ri-arrow-down-s-line text-xs"></i>}
              </a>
              {item.children && openMenu === item.label && (
                <div className="absolute top-full left-0 bg-white border border-gray-100 rounded-lg shadow-lg py-2 min-w-[220px] z-50">
                  {item.children.map((child) => (
                    <a
                      key={child.label}
                      href={child.href}
                      target={child.internal ? undefined : '_blank'}
                      rel="nofollow noreferrer"
                      onClick={(e) => handleChildClick(child, e)}
                      className="flex items-center gap-2 px-4 py-2 text-sm text-[#374151] hover:bg-orange-50 hover:text-[#e8600a] transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {child.icon && (
                        <span className="w-4 h-4 flex items-center justify-center">
                          <i className={`${child.icon} text-sm`}></i>
                        </span>
                      )}
                      {child.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Right actions */}
        <div className="hidden lg:flex items-center gap-4">
          <a
            href="/iletisim"
            onClick={(e) => { e.preventDefault(); navigate('/iletisim'); }}
            className="bg-[#e8600a] text-white text-sm font-semibold px-4 py-2 rounded-md hover:bg-[#cc5208] transition-colors cursor-pointer whitespace-nowrap"
          >
            İletişim
          </a>
        </div>
      </div>
    </nav>
  );
}
